module.exports = __webpack_public_path__ + "img/flag_valencian.1d30628d.png";